export const useEventBus = () => {
  const events = useState<Record<string, any>>('global-events', () => ({}));

  const emit = (name: string, payload?: any) => {
    events.value[name] = {payload, timestamp: Date.now()};
  };

  const on = (name: string, callback: (payload?: any) => void) => {
    watch(
      () => events.value[name],
      (newEvent) => {
        if (newEvent !== undefined) {
          callback(newEvent.payload);
          delete events.value[name];
        }
      },
      {deep: true, immediate: true}
    );
  };

  return {emit, on};
};
